// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormWrapper_formWrapper__7QiVe","formInput":"FormWrapper_formInput__07970","errorDisplay":"FormWrapper_errorDisplay__QABzF","formBox":"FormWrapper_formBox__MF3Yi"};